import { GetNotificationsResponse } from "@src/types/support";
import { v4 as uuidv4 } from "uuid";

export const mockNotifications: GetNotificationsResponse = [
  {
    type: "OPCUA_EVENT_CONTEXT",
    data_source_id: "cca3d528-c08b-808b-9c1c-ab10e2f9bc02",
    event_id: uuidv4(),
    event_type: "TemperatureAlarm",
    occured_at: "2026-03-10T10:15:30Z",
    received_at: "2026-03-10T10:15:31Z",
    severity: 892,
    level: "critical",
    message: "Boiler temperature exceeded critical threshold",
  },
  {
    type: "OPCUA_EVENT_CONTEXT",
    event_id: uuidv4(),
    event_type: "PressureAlarm",

    occured_at: "2026-03-10T11:05:12Z",
    received_at: "2026-03-10T11:05:13Z",
    severity: 611,
    level: "warning",
    message: "Pressure exceeded configured warning threshold",
  },
  {
    type: "OPCUA_EVENT_CONTEXT",
    event_id: uuidv4(),
    event_type: "HumidityAlarm",
    occured_at: "2026-03-10T11:20:02Z",
    received_at: "2026-03-10T11:20:03Z",
    severity: 145,
    level: "info",
    message: "Humidity is back in normal operating range",
  },
  {
    type: "OPCUA_EVENT_CONTEXT",
    event_id: uuidv4(),
    event_type: "FlowAlarm",
    source_node: "ns=2;s=Boiler.Flow.Sensor1",
    occured_at: "2026-03-10T11:24:40Z",
    received_at: "2026-03-10T11:24:41Z",
    severity: 777,
    level: "critical",
    message: "Flow dropped below minimum safe range",
  },
  {
    type: "OPCUA_EVENT_CONTEXT",
    event_id: uuidv4(),
    event_type: "VoltageAlarm",
    occured_at: "2026-03-10T11:31:10Z",
    received_at: "2026-03-10T11:31:11Z",
    severity: 534,
    level: "warning",
    message: "Input voltage fluctuated above warning threshold",
  },
];
